/**
 * Brand name shown in the UI, read from the runtime config (public/config.js).
 * There is no default: a missing or blank value fails fast.
 */
export const getBrandName = () => {
  const brandName = window.APP_CONFIG?.brandName;
  if (typeof brandName !== 'string' || !brandName.trim()) {
    throw new Error('[Brand] "brandName" is required in public/config.js');
  }
  return brandName.trim();
};
